import { FunctionComponent, useContext, useEffect } from 'react';

import { AdvertisingStore } from 'bernie-plugin-ads-loader-script';

import { SearchCriteriaContext } from 'stores/contexts';
import { SearchCriteriaModel } from 'stores/models/search-criteria-model';

import { TargetingEvent } from './types';

interface MesoScriptsProps {
  advertising?: AdvertisingStore;
}

export const MesoScripts: FunctionComponent<MesoScriptsProps> = props => {
  const searchCriteria: SearchCriteriaModel = useContext(SearchCriteriaContext);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { advertising } = props;
  // Do not perform this on the server side where window does not exist.
  if (typeof window !== 'undefined') {
    window.meso = window.meso || {};
    window.meso.targeting = window.meso.targeting || [];
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
      if (searchCriteria !== undefined) {
        const { regionId, startDate, endDate, adults, children, star, amenities, lodging, origin } = searchCriteria;
        const targetingEvent: TargetingEvent = {
          type: 'update',
          targeting: {
            dest: regionId,
            dateEnd: endDate,
            dateStart: startDate,
            adults,
            kids: children,
            locResolver: 'gaia',
            origin,
            ha: amenities?.toString() ?? '',
            hpt: lodging?.toString() ?? '',
            sr: star?.toString() ?? '',
          },
        };

        window.meso.targeting.push(targetingEvent);
      }
    }, []);
  }

  // This component does not render anything to the DOM.
  return null;
};
